import { useAppSelector } from 'app';
import { selectAppDevice } from 'slice';
import { DEVICES } from 'utils';

import StoreCreatePageContentDesktop from './ContentDesktop';
import StoreCreatePageContentMobile from './ContentMobile';

interface StoreCreatePageContentProps {
  handleSubmitStep: (e: number) => void;
  handleNextStep: () => any;
  ListStep: any[];
  isSubmitting: boolean;
  currentTab: number;
  handleChangeCurrentStep: (e: number) => void;
}

const Content = ({
  handleSubmitStep,
  handleNextStep,
  ListStep,
  isSubmitting,
  currentTab,
  handleChangeCurrentStep,
}: StoreCreatePageContentProps): JSX.Element => {
  const appDevice = useAppSelector(selectAppDevice);
  const props = {
    handleSubmitStep,
    handleNextStep,
    ListStep,
    isSubmitting,
    currentTab,
    handleChangeCurrentStep,
  };
  const renderElements = {
    [DEVICES.DESKTOP]: <StoreCreatePageContentDesktop {...props} />,
    [DEVICES.MOBILE]: <StoreCreatePageContentMobile {...props} />,
    [DEVICES.TABLET]: <StoreCreatePageContentMobile {...props} />,
  };
  return renderElements[appDevice.device];
};

export default Content;
